module.exports = __webpack_public_path__ + "static/img/wangxingxing.224a3d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/wangxingxing.jpg
// module id = ENGD
// module chunks = 0